<template>
    <el-form :model="signInForm" label-width="120px">
        <el-row :gutter="20">
            <el-col :span="6">
                <el-form-item label="订单号：">
                    <div class="inputValue">
                        {{ signInForm.orderNo }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="客户订单号：">
                    <div class="inputValue">
                        {{ signInForm.customerOrderNo }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="网点签收时间：">
                    <div class="inputValue">
                        {{ signInForm.networkSignTime }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="终端签收时间：">
                    <div class="inputValue">
                        {{ signInForm.finalSignTime }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="网点名称：">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signInForm.netName"
                        placement="top-start"
                    >
                        <div class="inputValue">
                            {{ signInForm.netName }}
                        </div>
                    </el-tooltip>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="网点联系方式：">
                    <div class="inputValue">
                        {{ signInForm.netMobileetMobile }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="网点详细地址：">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signInForm.networkAddr"
                        placement="top-start"
                    >
                        <div class="inputValue">
                            {{ signInForm.networkAddr }}
                        </div>
                    </el-tooltip>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="终端确认时间：">
                    <div class="inputValue">
                        {{ signInForm.finalConfirmTime }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="终端收货客户：">
                    <div class="inputValue">
                        {{ signInForm.finalName }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="终端联系方式：">
                    <div class="inputValue">
                        {{ signInForm.finalMobile }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="终端详细地址：">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signInForm.finalDetailAddr"
                        placement="top-start"
                    >
                        <div class="inputValue">
                            {{ signInForm.finalDetailAddr }}
                        </div>
                    </el-tooltip>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="增值服务类型：">
                    <div class="inputValue">
                        {{ signInForm.addedServiceTypeName }}
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>
<script>
export default {
    name: 'signInForm',
    data () {
        return {
            signInForm: {
                orderNo: '',
                customerOrderNo: '',
                networkSignTime: '',
                finalSignTime: '',
                netName: '',
                netMobileetMobile: '',
                networkAddr: '',
                finalConfirmTime: '',
                finalName: '',
                finalMobile: '',
                finalDetailAddr: '',
                addedServiceTypeName: ''
            }
        };
    },
    methods: {
        /**
         * @description 初始化用户签收详情表单字段值
         * @param {Object} data 接口返回的回单数据
         */
        initFormData (data) {
            Object.keys(this.signInForm).forEach(k => {
                this.signInForm[k] = data[k] || '';
            });
        }
    }
};
</script>
